<div
  class="auth-form mfa-form"
  *ngIf="email && token"
>
  <div class="auth-form__header">
    <p
      class="auth-form__description"
      [class.text-center]="!joiningEvent()"
      [innerHTML]="
        'UI.Authentication.EnterOTPCode'
          | translate
          | stringReplacement
            : {
                '{mail}': '<strong>' + email + '</strong>',
              }
      "
    ></p>
  </div>

  <form
    [formGroup]="form"
    (ngSubmit)="verified()"
  >
    <div class="form-group">
      <input
        type="text"
        class="form-control otp-input"
        id="otp"
        formControlName="otp"
        inputmode="numeric"
        pattern="[0-9]*"
        maxlength="6"
        placeholder="_ _ _ _ _ _"
      />
    </div>

    <div
      class="form-group email-confirmation__buttons mb-3"
      [class.text-center]="!joiningEvent()"
    >
      <button
        type="submit"
        class="btn btn-primary"
        [disabled]="form.invalid || requesting"
      >
        <ng-container *ngIf="requesting">
          <span
            class="spinner-border spinner-border-sm"
            aria-hidden="true"
          ></span>
        </ng-container>
        <span class="ms-2">{{ 'Verify' | translate }}</span>
      </button>
    </div>
  </form>

  <p
    class="auth-form__description mb-0"
    translate
    [class.text-center]="!joiningEvent()"
  >
    {{ 'UI.Authentication.DidNotReceiveCode' | translate }}
  </p>

  <div class="d-flex justify-content-center align-items-center">
    <button
      class="btn-unstyled"
      [class.text-center]="!joiningEvent()"
      (click)="resendCode()"
    >
      <span
        class="resend-code-btn"
        [class.disabled]="resendCodeTime > 0"
        >{{ 'UI.Authentication.ResendCode' | translate }}</span
      >({{ resendCodeTime }})
    </button>
  </div>
</div>
